import { ToastMessageOptions } from "primevue/toast";
import { useToast } from "primevue/usetoast";

export const TOAST_TIME_DURATION = 4000; // in ms

export function useToaster() {
  const toast = useToast();

  function add(opts: Partial<ToastMessageOptions>) {
    toast.add({
      life: TOAST_TIME_DURATION,
      ...opts,
    });
  }

  return {
    add,
  };
}
